const undergraduateRouter = [
  // 主页
  {
    path: '/undergraduate',
    name: 'undergraduate-home',
    redirect: '/undergraduate/index',
    component: () => import('@/view/undergraduate/home'),
    children: [
      {
        path: 'index',
        name: 'undergraduate-home-index',
        // 页面访问权限
        meta: {
          role: ['UGDCM', 'UGDEM', 'UGDFAO'],
          menu: 'home'
        },
        redirect: '/undergraduate/index/appointment',
        component: () => import('@/view/undergraduate/home/home-main'),
        children: [
          {
            path: 'appointment',
            name: 'undergraduate-home-appointment',
            meta: {
              role: ['UGDCM', 'UGDEM', 'UGDFAO'],
              menu: 'home',
              task: 'appointment'
            },
            component: () => import('@/view/undergraduate/home/appointment')
          }
        ]
      },
      // 学生信息页面
      {
        path: 'mentee',
        name: 'undergraduate-mentee-index',
        // 页面访问权限
        meta: {
          role: ['UGDCM', 'UGDEM', 'UGDFAO'],
          menu: 'mentee'
        },
        component: () => import('@/view/undergraduate/mentee/index')
      },
      {
        path: 'mentee/:id',
        name: 'undergraduate-mentee-main',
        meta: {
          menu: 'mentee'
        },
        redirect: {
          name: 'undergraduate-mentee-activity'
        },
        component: () => import('@/view/undergraduate/mentee/main'),
        children: [
          {
            path: 'activity',
            name: 'undergraduate-mentee-activity',
            meta: {
              menu: 'mentee',
              info: 'activity'
            },
            redirect: {
              name: 'undergraduate-mentee-activity-appointment'
            },
            component: () => import('@/view/undergraduate/mentee/activity'),
            children: [
              {
                path: 'appointment',
                name: 'undergraduate-mentee-activity-appointment',
                meta: {
                  role: ['UGDCM', 'UGDEM', 'UGDFAO'],
                  menu: 'mentee',
                  info: 'activity',
                  behavior: 'appointment'
                },
                component: () =>
                  import('@/view/undergraduate/mentee/appointment')
              },
              {
                path: 'appointment/:appointId',
                name: 'undergraduate-mentee-appointment-detail',
                meta: {
                  role: ['UGDCM', 'UGDEM', 'UGDFAO'],
                  menu: 'mentee',
                  info: 'activity',
                  behavior: 'appointment'
                },
                component: () =>
                  import('@/view/undergraduate/mentee/appointment-detail.vue')
              }
            ]
          },
          {
            path: 'school',
            name: 'undergraduate-mentee-school',
            meta: {
              role: ['UGDCM', 'UGDEM', 'UGDFAO'],
              menu: 'mentee',
              info: 'school'
            },
            component: () => import('@/view/undergraduate/mentee/school')
          },
          {
            path: 'information',
            name: 'undergraduate-mentee-information',
            meta: {
              menu: 'mentee',
              info: 'information'
            },
            redirect: {
              name: 'undergraduate-mentee-cv-base'
            },
            component: () => import('@/view/undergraduate/mentee/information'),
            children: [
              {
                path: 'base',
                name: 'undergraduate-mentee-cv-base',
                meta: {
                  role: ['UGDCM', 'UGDEM', 'UGDFAO'],
                  menu: 'mentee',
                  info: 'information',
                  kind: 'base'
                },
                component: () =>
                  import('@/view/undergraduate/mentee/cv/cv-base')
              },
              {
                path: 'personal',
                name: 'undergraduate-mentee-cv-personal',
                meta: {
                  role: ['UGDCM', 'UGDEM', 'UGDFAO'],
                  menu: 'mentee',
                  info: 'information',
                  kind: 'personal'
                },
                component: () =>
                  import('@/view/undergraduate/mentee/cv/cv-personal')
              },
              {
                path: 'education',
                name: 'undergraduate-mentee-cv-education',
                meta: {
                  role: ['UGDCM', 'UGDEM', 'UGDFAO'],
                  menu: 'mentee',
                  info: 'information',
                  kind: 'education'
                },
                component: () =>
                  import('@/view/undergraduate/mentee/cv/cv-education')
              },
              {
                path: 'course',
                name: 'undergraduate-mentee-cv-course',
                meta: {
                  role: ['UGDCM', 'UGDEM', 'UGDFAO'],
                  menu: 'mentee',
                  info: 'information',
                  kind: 'course'
                },
                component: () =>
                  import('@/view/undergraduate/mentee/cv/cv-course')
              },
              {
                path: 'score',
                name: 'undergraduate-mentee-cv-score',
                meta: {
                  role: ['UGDCM', 'UGDEM', 'UGDFAO'],
                  menu: 'mentee',
                  info: 'information',
                  kind: 'score'
                },
                component: () =>
                  import('@/view/undergraduate/mentee/cv/cv-score')
              },
              {
                path: 'credit',
                name: 'undergraduate-mentee-cv-credit',
                meta: {
                  role: ['UGDCM', 'UGDEM', 'UGDFAO'],
                  menu: 'mentee',
                  info: 'information',
                  kind: 'credit'
                },
                component: () =>
                  import('@/view/undergraduate/mentee/cv/cv-credit')
              },
              {
                path: 'awards',
                name: 'undergraduate-mentee-cv-awards',
                meta: {
                  role: ['UGDCM', 'UGDEM', 'UGDFAO'],
                  menu: 'mentee',
                  info: 'information',
                  kind: 'awards'
                },
                component: () =>
                  import('@/view/undergraduate/mentee/cv/cv-awards')
              },
              {
                path: 'activity',
                name: 'undergraduate-mentee-cv-activity',
                meta: {
                  role: ['UGDCM', 'UGDEM', 'UGDFAO'],
                  menu: 'mentee',
                  info: 'information',
                  kind: 'activity'
                },
                component: () =>
                  import('@/view/undergraduate/mentee/cv/cv-activity')
              },
              {
                path: 'hobby',
                name: 'undergraduate-mentee-cv-hobby',
                meta: {
                  role: ['UGDCM', 'UGDEM', 'UGDFAO'],
                  menu: 'mentee',
                  info: 'information',
                  kind: 'hobby'
                },
                component: () =>
                  import('@/view/undergraduate/mentee/cv/cv-hobby')
              }
            ]
          }
        ]
      },
      {
        path: 'materials',
        name: 'undergraduate-materials-main',
        meta: {
          role: ['UGDCM', 'UGDEM', 'UGDFAO'],
          menu: 'materials'
        },
        component: () => import('@/view/undergraduate/materials/main')
      },
      // timesheet
      {
        path: 'timesheet',
        name: 'undergraduate-timesheet',
        meta: {
          role: ['UGDCM', 'UGDEM', 'UGDFAO'],
          menu: 'timesheet'
        },
        component: () => import('@/view/undergraduate/timesheet/timesheet')
      },
      // 个人页面
      {
        path: 'personal',
        name: 'undergraduate-personal',
        meta: {
          menu: 'personal'
        },
        redirect: {
          name: 'undergraduate-personal-info'
        },
        component: () => import('@/view/undergraduate/personal'),
        children: [
          {
            path: 'info',
            name: 'undergraduate-personal-info',
            meta: {
              role: ['UGDCM', 'UGDEM', 'UGDFAO'],
              menu: 'personal'
            },
            component: () =>
              import('@/view/undergraduate/personal/personal-info')
          },
          {
            path: 'message',
            name: 'undergraduate-personal-message',
            meta: {
              role: ['UGDCM', 'UGDEM', 'UGDFAO'],
              menu: 'personal'
            },
            component: () =>
              import('@/view/undergraduate/personal/personal-message')
          },
          {
            path: 'modify-password',
            name: 'undergraduate-personal-modify-password',
            meta: {
              role: ['UGDCM', 'UGDEM', 'UGDFAO'],
              menu: 'personal'
            },
            component: () =>
              import('@/view/undergraduate/personal/personal-modify-password')
          }
        ]
      },
      // 站内信wechat
      {
        path: 'wechat',
        name: 'undergraduate-wechat',
        meta: {
          role: ['UGDCM', 'UGDEM', 'UGDFAO']
        },
        component: () => import('@/view/undergraduate/home/wechat')
      },
      // 问题反馈
      {
        path: 'feedback',
        name: 'undergraduate-feedback',
        meta: {
          role: ['UGDCM', 'UGDEM', 'UGDFAO']
        },
        component: () => import('@/view/undergraduate/home/feedback')
      }
    ]
  }
]
export default undergraduateRouter
